module.exports = __webpack_public_path__ + "img/mirror22.465f81f4.jpg";